/**
 * Versão do sistema de cobranças
 * Esta versão é exibida na barra lateral para informar aos usuários sobre atualizações
 */
export const SYSTEM_VERSION = '2.0.52';

/**
 * Data da última atualização (formato: DD/MM/YYYY)
 */
export const LAST_UPDATE_DATE = '28/04/2026';
